import serviceWorkerReducer from './service-worker.reducers'

export default serviceWorkerReducer
